/**
 * US-11: Email verification for complimentary AI pass (server checks emailVerified).
 * Link is generated with Firebase Admin; message is sent via Resend (see /api/email-verification-send).
 */
import { reload } from 'firebase/auth';
import { auth } from '../firebase';
import { requestEmailVerificationSend } from './email';

/**
 * Send verification email (Resend + Firebase action link).
 * No-op if already verified or no user.
 * @returns {Promise<'sent' | 'already_verified' | 'no_email'>}
 */
export async function sendFirebaseVerificationEmail() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('You must be signed in to verify your email.');
  }
  if (user.emailVerified) {
    return 'already_verified';
  }
  if (!user.email) {
    return 'no_email';
  }
  const result = await requestEmailVerificationSend();
  if (result.alreadyVerified) {
    return 'already_verified';
  }
  return 'sent';
}

/**
 * Reload current user from Firebase (pick up emailVerified after clicking link).
 */
export async function reloadCurrentAuthUser() {
  const user = auth.currentUser;
  if (!user) return;
  await reload(user);
}
